<app-page title="Contact Us">
  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="mb-6">
        <h2 class="mt-0 mb-3">Technical Assistance</h2>
        <a class="p2 no-underline" href="tel:{{ CcsConfig.helpPhone }}"
          ><i class="mi-round mi-call mr-3 -mt-1 vertical-align-middle phone-icon"></i>{{ CcsConfig.helpPhone }}</a
        >
      </div>
      <div class="mb-6">
        <h2 class="mt-0 mb-3">Send Us an Email</h2>
        <a class="p2 no-underline" href="mailto:{{ CcsConfig.helpEmail }}"
          ><i class="mi-round mi-mail-outline mr-3 -mt-1 vertical-align-middle mail-icon"></i
          >{{ CcsConfig.helpEmail }}</a
        >
      </div>
      <div class="mb-0 md:mb-6">
        <h2 class="mt-0 mb-3">Give us a Call</h2>
        <a class="p2 no-underline" href="tel:+1-888-633-4225"
          ><i class="mi-round mi-call mr-3 -mt-1 vertical-align-middle phone-icon"></i>1-888-Medical</a
        >
        <p class="p2 mb-0 font-semibold text-black-400">Hours of Operation</p>
        <p class="p2 mt-0 text-black-400">8am - 6pm ET, Monday - Friday</p>
      </div>
    </div>
    <div class="col-12 md:col-6">
      <div>
        <h2 class="mt-0 mb-3">Specialist Contact</h2>
        <div class="flex mb-5">
          <i class="mi-round mi-call mr-4 mt-1 vertical-align-middle phone-icon"></i>
          <div>
            <p class="p2 mt-0 mb-2 font-semibold text-black-400">Wound Care</p>
            <a class="p2 no-underline" href="tel:+1-800-690-1255">1-800-690-1255</a>
          </div>
        </div>
        <div class="flex mb-5">
          <i class="mi-round mi-call mr-4 mt-1 vertical-align-middle phone-icon"></i>
          <div>
            <p class="p2 mt-0 mb-2 font-semibold text-black-400">Pharmacy</p>
            <a class="p2 no-underline" href="tel:+1-888-308-8882">1-888-308-8882</a>
          </div>
        </div>
        <div class="flex mb-5">
          <i class="mi-round mi-call mr-4 mt-1 vertical-align-middle phone-icon"></i>
          <div>
            <p class="p2 mt-0 mb-2 font-semibold text-black-400">Living Connected</p>
            <a class="p2 no-underline" href="tel:+1-800-966-2046">1-800-966-2046</a>
          </div>
        </div>
        <div class="flex">
          <i class="mi-round mi-call mr-4 mt-1 vertical-align-middle phone-icon"></i>
          <div>
            <p class="p2 mt-0 mb-2 font-semibold text-black-400">Ostomy/Urology</p>
            <a class="p2 no-underline" href="tel:+1-800-722-2604">1-800-722-2604</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page>
